


































import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class Dates extends Vue {
  private headers = [
    {
      text: 'data',
      align: 'left',
      value: 'date',
      sortable: false
    },
    {
      text: 'data2',
      align: 'right',
      value: 'date',
      sortable: false
    }
  ]

  private dates = [
    {
      date: '01 a 23 de março de 2024',
      event: 'Período para encaminhamento dos artigos e resumos expandidos',
      disabled: false
    },
    {
      date: '24 de março até 01 de abril de 2024',
      event: 'Período para avaliação, revisão e correção dos artigos e resumos expandidos',
      disabled: false
    },
    {
      date: '19 de abril de 2024',
      event: 'Apresentação dos artigos e resumos expandidos na III JCPOLI',
      disabled: false
    }
  ]

  constructor() {
    super()
  }
}
